export default __webpack_public_path__ + "static/media/alzheimer.3f98e44d.png";